import { Spin, Typography } from "antd";
import { useTranslation } from "react-i18next";

import colors from "../../../../../../../themes/colors";
import { formatDate } from "../../../../utils";
import { Completeness } from "./completeness";
import { QuestionnaireEntry } from "./questionnaireEntries";
import QuestionnaireCard from "./QuestionnaireCard";
import { CardsWrapper, OverviewBlock } from "./styledComponents";

const { Text, Title } = Typography;

/** One tax return (business or private): heading, completeness and its cards. */
const TaxReturnSection = ({
  title,
  completeness,
  entries,
  taxYear,
  isLoading,
  isLoadingEntries,
  isNotRelevant,
}: {
  title: string;
  // Undefined when the tax case is not loaded, e.g. without permission
  completeness?: Completeness;
  entries: QuestionnaireEntry[];
  taxYear: number;
  isLoading: boolean;
  // Cards a company cannot fill in must not flash in and out.
  isLoadingEntries: boolean;
  isNotRelevant: boolean;
}) => {
  const { t } = useTranslation("TaxCaseOverview", {
    keyPrefix: "completenessOverview",
  });

  const isOpen = !!completeness && "date" in completeness && !completeness.date;
  const value = !completeness
    ? null
    : "notRelevant" in completeness
    ? t("notRelevant")
    : formatDate(completeness.date) ?? t("open");

  return (
    <OverviewBlock>
      <Title level={4}>{title}</Title>
      {value && (
        // Same colours as the card status lines: green once fulfilled.
        <Text
          style={{
            display: "block",
            color: isOpen ? colors.lightGreyOpacity : colors.darkLimeGreen,
          }}
        >
          {t("completeness", { value })}
        </Text>
      )}
      {isLoadingEntries ? (
        <Spin />
      ) : (
        !!entries.length && (
          <CardsWrapper className="mt-3">
            {entries.map(({ key, info, questionnaire }) => (
              <QuestionnaireCard
                key={key}
                taxYear={taxYear}
                info={info}
                questionnaire={questionnaire}
                loading={isLoading}
                detailedStatus
                isNotRelevant={isNotRelevant}
              />
            ))}
          </CardsWrapper>
        )
      )}
    </OverviewBlock>
  );
};

export default TaxReturnSection;
